import { createStyles } from '@material-ui/core/styles';

export const popOverStyles = createStyles({
  root: {
    boxShadow: `0 1px 6px 0 rgba(69, 69, 69, 0.2),
      0 1px 5px 0 rgba(69, 69, 69, 0.1)`
  }
});

export const keyBoardButtonStyles = createStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

export const inputAdornmentStyles = createStyles({
  positionStart: {
    marginRight: '4px'
  }
});

const styles = createStyles({
  root: {
    maxWidth: '128px',
    width: '100%',
    height: '32px'
  }
});

export default styles;
